import { IFinishDataHouses } from '../../../types/newbuilding/housesByTurn';
import { ITitleValueListItem } from '../../../types/titleValueList';

export function convertFinishDateToTitleValue(items: IFinishDataHouses[]): ITitleValueListItem[] {
  return items.map(({ date, housesNames }) => ({
    title: date,
    value: housesNames,
  }));
}
